import { render } from "./LoadingBlock.vue?vue&type=template&id=0327e711&scoped=true"
import script from "./LoadingBlock.vue?vue&type=script&lang=js"
export * from "./LoadingBlock.vue?vue&type=script&lang=js"

import "./LoadingBlock.vue?vue&type=style&index=0&id=0327e711&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0327e711"]])

export default __exports__